export default {
  bean: {
    actionNew: '新建',
    actionExport: '導出',
    actionImport: '導入',
    actionEdit: '編輯',
    actionDetail: '詳情',
    actionSubmit: '提交',
    actionFilter: '篩選',
    actionReset: '重置',
    actionConfirm: '確定',
    actionClose: '關閉',
    actionCancel: '取消',
    actionAdd: '添加',
    actionExpand: '展開',
    actionCollapse: '收起',
    actionUpload: '上傳',
    actionDelete: '刪除',
    actionQuery: '查詢',
    actionNavBack: '返回',
    actionOperation: '操作',
    actionChooseFile: '選擇文件',
    actionChooseDirectory: '選擇文件夾',
    actionUploadAll: '全部上傳',
    actionRemoveAll: '全部移除',
    actionSelectAll: '全部选择',
    actionRemove: '移除',
    actionLogout: '退出登錄',
    actionTableToExcel: '導出表格',
    deleteSuccess: '刪除成功',
    createSuccess: '創建成功',
    updateSuccess: '更新成功',
    uploadSuccess: '上傳成功',
    fieldRequired: '{field}必填',
    dragSort: '拖拽排序',
    imageResizer: '圖片裁剪',
    resizeImage: '裁剪圖像',
    imageResized: '已裁剪',
    maximumFileSize: '文件大小最大: {size}',
    maximumUploadFileCount: '最多可上傳{count}個文件',
    fileTypeisInvalid: '文件格式不對',
    dragAndDropUpload: '將文件拖曳到此處，或點擊上傳',
    filteredUploadFileTip: '已過濾不符合要求的文件',
    chooseBlobTagTip: '選擇標籤 標籤將作用於即將上傳的所有圖片',
    fileFormat: '文件格式',
    folder: '文件夾',
    fileName: '文件名',
    fileSize: '文件大小',
    fileType: '文件類型',
    tag: '標籤',
    confirmDeleteTip: '確定刪除？ ',
    selectCountItem: '可選擇{count}項',
    yes: '是',
    no: '否',
    link: '鏈接',
    list: '列表',
    all: '所有',
    selected: '已選擇：',
    blankSelected: '已選擇為空',
    noOptions: '沒有可選擇項',
    enterKeywordFiltering: '輸入關鍵字過濾',
    error_massage: '錯誤信息',
    importSuccess: '導入成功',
    importFail: '導入失敗，請查看"錯誤信息.xlsx"文件了解詳情',
    formValidateError: '表單項填寫有錯誤',
    selectEvent: '選擇事件',
    checksumPending: '文件校驗中...',
    addNewOptionType: '新建規格',
    optionTypes: '規格',
    editVariant: '編輯SKU',
    chooseOptionType: '選擇使用規格',
    pleaseInputOptionTypeName: '請輸入規格名',
    pleaseInputOptionValueName: '請輸入規格值',
    pleaseInputNewOptionTypeName: '請輸入新名稱',
    pleaseInputNewOptionValueName: '請輸入新名稱',
    pageGenerator: {
      text: '文字',
      title: '標題',
      richText: '富文本',
      image: '圖片',
      imageHotArea: '圖片熱區',
      multipleImage: '一行多圖',
      video: '視頻',
      swiper: '輪播圖',
      splitLine: '分割線',
      blank: '留白',
      scrollX: '左右滑動圖',
      map: '地圖',
      navbar: '導航條',
      form: '表單',
      popup: '彈窗',
      fixedButton: '側邊固定按鈕',
      zIndex: '層級',
      zIndexBigOneOnTop: '層級大的在上面',
      save: '保存',
      hotArea: '熱區',
      shareTitle: '分享標題',
      shareImage: '分享圖片',
      posterBackgroundImage: '海報圖片',
      posterBackgroundColor: '海報背景色',
      posterText: '海報文案',
      posterTextColor: '海報文案顏色',
      titleBackgroundColor: '標題背景色',
      titleColor: '標題顏色',
      backgroundColor: '背景顏色',
      paddingTop: '上間距',
      paddingBottom: '下間距',
      paddingLeft: '左間距',
      paddingRight: '右間距',
      white: '白色',
      black: '黑色',
      imageSize: '圖片寬高{size}',
      pageSettings: '頁面設定',
      componentSettings: '組件設定',
      baseSettings: '基本設定',
      styleSettings: '樣式設定',
      eventSettings: '事件設定',
      animationSettings: '動畫設定',
      moduleName: '模塊名稱',
      moduleNameTip: '僅用於標記，可不填，不影響用戶端頁面渲染',
      navigateType: '跳轉類型',
      miniprogramPage: '小程式內頁',
      externalMiniprogramPage: '其他小程式頁面',
      webviewPage: 'webview頁面',
      selectPage: '選擇頁面',
      selectComponent: '選擇组件',
      webviewLink: 'wenbview地址',
      externalMiniprogramPageAppid: '跳轉小程式的appid',
      externalMiniprogramPagePath: '跳轉小程式的頁面路徑',
      address: '地址名',
      longitude: '經度',
      latitude: '緯度',
      navigateToPage: '跳轉頁面',
      makePhoneCall: '撥打電話',
      openMap: '打開地圖查看地址',
      shareWithFriend: '分享給好友（觸發頁面設定分享）',
      shareByPoster: '生成海報（觸發頁面設定生成海報）',
      contact: '聯系客服',
      previewImage: '圖片預覽',
      phoneNumber: '電話號碼',
      selectPopup: '選擇彈窗',
      height: '高度',
      buttonPosition: '按鈕位置',
      lateralDistance: '橫向距離',
      longitudinalDistance: '縱向距離',
      buttomImage: '按鈕圖片',
      buttonWidth: '按鈕寬度',
      buttonHeight: '按鈕高度',
      buttonZIndex: '按鈕層級',
      buttonZIndexInfo: '多個固定按鈕，層級高的會顯示在上面',
      rightBottom: '右下',
      rightTop: '右上',
      leftBottom: '左下',
      leftTop: '左上',
      distanceWithWindow: '距離可視視窗{position}距離',
      leftSide: '左邊',
      rightSide: '右邊',
      topSide: '頂部',
      bottomSide: '底部',
      formInputPlaceHolder: '請輸入姓名',
      formTelPlaceHolder: '請輸入聯繫電話',
      formEmailPlaceHolder: '請輸入郵箱地址',
      formContentPlaceHolder: '請輸入內容',
      setting: '設定',
      inputFontColor: '輸入字體顏色',
      borderColor: '邊框色',
      inputBorderRadius: '輸入框圓角',
      fontSize: '文字大小',
      fontColor: '文字顏色',
      selectedStateColor: '選中狀態顏色',
      buttonFontSize: '按鈕字體大小',
      buttonFontColor: '按鈕字體顏色',
      buttonBackgroundColor: '按鈕背景色',
      buttonBorderRadius: '按鈕圓角',
      selectImage: '選擇圖片',
      relativeWithContainerWidth: '相對於容器寬度百分比',
      alignType: '對齊管道',
      alignLeft: '左對齊',
      alignCenter: '居中對齊',
      alignRight: '右對齊',
      imageList: '圖片清單',
      imageSpacing: '圖片間距',
      verticalAlignment: '垂直對齊',
      alignTop: '上對齊',
      alignBottom: '下對齊',
      navbarType: '樣式',
      'navbarType1': '樣式1',
      'navbarType2': '樣式2',
      navbarItems: '導航',
      isSelected: '是否選中',
      popupName: '彈窗名稱',
      popupAutoOpen: '自動彈窗',
      popupShowTimes: '自動彈窗次數',
      popupShowTimesTip: '選擇了“自動彈窗”，才會生效',
      popupCloseButtonTriggerEvent: '關閉按鈕觸發事件',
      popupCloseButtonTip: '點底部“x”按鈕時觸發關閉彈窗的同時也觸發“事件設定”',
      popupRenderHeight: '展示高度',
      popupBorderRadius: '彈窗圓角',
      textAlign: '文字對齊',
      imageWidth: '圖片寬度',
      imageHeight: '圖片高度',
      titleFontSize: '標題字型大小',
      titleTextColor: '標題顏色',
      titleLineHeight: '標題行高',
      subtitleFontSize: '副標題字型大小',
      subtitleTextColor: '副標題顏色',
      subtitleLineHeight: '副標題行高',
      desTextFontSize: '介紹字型大小',
      desTextColor: '介紹字型大小',
      desTextLineHeight: '介紹行高',
      lineColor: '線條顏色',
      lineBorderWidth: '線條粗細',
      lineType: '線條類型',
      solid: '實線',
      dashed: '虛線',
      dotted: '點',
      indicatorDots: '顯示面板訓示點',
      indicatorColor: '訓示點顏色',
      indicatorActiveColor: '當前選中的訓示點顏色',
      swiperAutoplay: '自動切換',
      swiperInterval: '自動切換時間間隔',
      swiperDuration: '滑動動畫時長',
      swiperCircular: '是否採用銜接滑動',
      noPreviewResult: '無預覽效果',
      addImage: '添加圖片',
      sort: '排序',
      swiperTextBackgroundColor: '文字欄背景色',
      swiperTextPaddingTop: '文字欄上間距',
      swiperTextPaddingBottom: '文字欄下間距',
      swiperTextPaddingLeft: '文字欄左間距',
      swiperTextPaddingRight: '文字欄右間距',
      lineHeight: '行高',
      color: '顏色',
      fontWeight: '字重',
      fontWeightNormal: '默認',
      fontWeightBold: '加粗',
      titleStyle: '風格',
      'titleStyle1': '風格1',
      'titleStyle2': '風格2',
      titleStyleBackgroundColor: '風格顏色',
      uploadVideo: '上傳視頻',
      videoPoster: '視頻封面',
      videoShowControls: '顯示播放控制項',
      videoAutoplay: '自動播放',
      videoLoop: '迴圈播放',
      videoMuted: '靜音播放',
      objectFit: '顯示形式',
      contain: '包含',
      fill: '填充',
      cover: '覆蓋',
      animationType: '動畫類型',
      fade: '淡入',
      scaleUp: '放大',
      scaleDown: '縮小',
      slideTop: '上滑進入',
      slideBottom: '下滑進入',
      slideLeft: '左滑進入',
      slideRight: '右滑進入',
      shake: '抖動',
      moveForward: '前移',
      moveBack: '後移',
      collapse: '折疊面板',
      collapseItems: '折疊項',
      collapseContent: '折疊內容',
      collapseTitle: '折疊標題',
      collapseIndicator: '指示Icon'
    }
  }
}
